<script setup lang="ts">
import {onUnmounted, reactive, ref, computed, watch} from "vue";
import { usePointerSwipe } from '@vueuse/core'
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import {isMobileDevice} from '@/utils/windowUtils';

const emits = defineEmits(["update:visible", "cancel"])

const props = defineProps({
  title: {
    default: ''
  },
  footer: {
    default: false,
  },
  visible: {
    default: false,
  },
  hideExit: {
    default: false,
  },
  maxHeight: {
    default: false,
  }
})
const closeSlide = () => {
  if (contentRef.value) {
    enableBodyScroll(contentRef.value); // 명시적 해제
  }
  clearAllBodyScrollLocks()
  emits("cancel")
  emits("update:visible", false);
}
const footerRef = ref();
const contentRef = ref();
const frameRef = ref();
const start = ref();
const diff = ref();
const heights = reactive({
  frame: {
    default: -1,
    start: -1,
  },
  content: {
    default: -1,
    start: -1,
  },
  footer: {
    default: -1,
  },
});
const getFooterBottom = () => {
  return footerRef.value.getBoundingClientRect().bottom;
};

const { distanceY, isSwiping } = usePointerSwipe(frameRef, {
  onSwipeEnd(e, direction) {
    if (distanceY.value < -100 && direction === 'down') {
      closeSlide()
    }
  },
})

const transformStyle = computed(() => {
  if (isSwiping.value && distanceY.value < 0) {
    return {
      transform: `translateY(${-distanceY.value}px)`,
      transition: 'none' // 드래그 중에는 애니메이션 무효화
    }
  }
  return {
    transform: `translateY(0px)`,
    transition: 'transform 0.3s ease-out'
  }
})

const clickBack = () => {
  if (!props.hideExit) {
    closeSlide()
  }
}

watch(() => props.visible, (val) => {
  if (val) {
    setTimeout(() => {
      if (contentRef.value) {
        disableBodyScroll(contentRef.value, {
          reserveScrollBarGap: true,
        });
      }
    }, 0);
  } else {
    if (contentRef.value) {
      enableBodyScroll(contentRef.value);
    }
  }
}, { immediate: true })

onUnmounted(() => {
  clearAllBodyScrollLocks()
})
</script>

<template>
  <Teleport to="#teleport">
    <div v-if="visible" class="bottom-slide-sheet" :class="{ visible }">
      <div class="slide-back" @click="clickBack"/>
      <div class="slide-frame" :style="transformStyle" ref="frameRef">
        <div v-if="title" class="slide-header">
          <div  v-if="!hideExit" class="header-left"></div>
          <span>{{ $t(title) }}</span>
          <img v-if="!hideExit" src="@/assets/images/icons/close_24.svg" class="cursor-pointer" @click="closeSlide">
        </div>
        <div v-else-if="!title && !isMobileDevice()" class="slide-header">
          <div class="header-left"></div>
          <span> </span>
          <img src="@/assets/images/icons/close_24.svg" @click="closeSlide">
        </div>
        <div v-else class="slide-header">
          <div class="top-bar" />
        </div>
        <div :class="maxHeight ? 'slide-content-max' : ''"  class="slide-content" ref="contentRef">
          <slot name="content" />
        </div>
        <div class="slide-footer" v-if="footer" ref="footerRef">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped></style>


<!--<template>-->
<!--  <div :class="visible ? 'bottom-slide-sheet' : 'bottom-slide-sheet-hidden'" @wheel.prevent>-->
<!--    <div class="slide-back" @click="clickBack"/>-->
<!--    <div class="slide-frame" :style="`animation-duration: ${duration}s`" ref="frameRef">-->
<!--      <div v-if="title" class="slide-header">-->
<!--        <div  v-if="!hideExit" class="header-left"></div>-->
<!--        <span>{{ $t(title) }}</span>-->
<!--        <img v-if="!hideExit" src="@/assets/images/icons/close_24.svg" class="cursor-pointer" @click="closeSlide">-->
<!--      </div>-->
<!--      <div v-else-if="!title && !isMobileDevice()" class="slide-header">-->
<!--        <div class="header-left"></div>-->
<!--        <span> </span>-->
<!--        <img src="@/assets/images/icons/close_24.svg" @click="closeSlide">-->
<!--      </div>-->
<!--      <div-->
<!--          v-else-->
<!--          class="slide-header"-->
<!--          @touchmove="moveTouch"-->
<!--          @touchstart="startTouch"-->
<!--          @touchend="endTouch"-->
<!--      >-->
<!--        <div class="top-bar" />-->
<!--      </div>-->
<!--      <div-->
<!--          :class="maxHeight ? 'slide-content-max' : ''"-->
<!--          class="slide-content"-->
<!--          ref="contentRef"-->
<!--          @touchstart="startTouch"-->
<!--          @touchmove="contentMoveTouch"-->
<!--          @touchend="endTouch"-->
<!--      >-->
<!--        <slot name="content" />-->
<!--      </div>-->
<!--      <div class="slide-footer" v-if="footer" ref="footerRef">-->
<!--        <slot name="footer" />-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script lang="ts">-->
<!--import {defineComponent, onUnmounted, reactive, ref} from "vue";-->
<!--import {isMobileDevice} from '@/utils/windowUtils';-->

<!--export default defineComponent({-->
<!--  name: "BottomSlideSheet",-->
<!--  methods: {isMobileDevice},-->
<!--  emit: ["update:visible", "cancel"],-->
<!--  props: {-->
<!--    title: {-->
<!--      default: ''-->
<!--    },-->
<!--    footer: {-->
<!--      default: false,-->
<!--    },-->
<!--    visible: {-->
<!--      default: false,-->
<!--    },-->
<!--    duration: {-->
<!--      default: 0.5,-->
<!--    },-->
<!--    hideExit: {-->
<!--      default: false,-->
<!--    },-->
<!--    maxHeight: {-->
<!--      default: false,-->
<!--    }-->
<!--  },-->
<!--  setup(props, context) {-->
<!--    const closeSlide = () => {-->
<!--      context.emit("cancel")-->
<!--      document.body.style.overflow = 'auto'-->
<!--      context.emit("update:visible", false);-->
<!--    }-->
<!--    const footerRef = ref();-->
<!--    const contentRef = ref();-->
<!--    const frameRef = ref();-->
<!--    const start = ref();-->
<!--    const diff = ref();-->
<!--    const heights = reactive({-->
<!--      frame: {-->
<!--        default: -1,-->
<!--        start: -1,-->
<!--      },-->
<!--      content: {-->
<!--        default: -1,-->
<!--        start: -1,-->
<!--      },-->
<!--      footer: {-->
<!--        default: -1,-->
<!--      },-->
<!--    });-->
<!--    const getFooterBottom = () => {-->
<!--      return footerRef.value.getBoundingClientRect().bottom;-->
<!--    };-->
<!--    const setDefault = (state: 'set' | 'default') => {-->
<!--      if (heights.frame.default < 0) {-->
<!--        heights.frame.default = frameRef.value.offsetHeight;-->
<!--      } else if (state === 'default') frameRef.value.style.height = `${heights.frame.default}px`;-->
<!--      if (heights.content.default < 0) {-->
<!--        heights.content.default = contentRef.value.offsetHeight;-->
<!--      } else if (state === 'default')-->
<!--        contentRef.value.style.height = `${heights.content.default}px`;-->
<!--      if (props.footer) heights.footer.default = getFooterBottom();-->
<!--    };-->
<!--    const startTouch = (e: TouchEvent) => {-->
<!--      setDefault('set');-->
<!--      diff.value = 0;-->
<!--      start.value = e.targetTouches[0].screenY;-->
<!--      heights.frame.start = frameRef.value.offsetHeight;-->
<!--      heights.content.start = contentRef.value.offsetHeight;-->
<!--    };-->

<!--    const moveTouch = (e: TouchEvent) => {-->
<!--      // if (props.footer && heights.footer.default !== getFooterBottom()) return-->
<!--      const changeY = e.changedTouches[0].screenY;-->
<!--      diff.value = start.value - changeY;-->
<!--      if (diff.value <= 0 && !props.hideExit) {-->
<!--        frameRef.value.style.height = `${heights.frame.start + diff.value}px`;-->
<!--        contentRef.value.style.height = `${heights.content.start + diff.value}px`;-->
<!--      }-->
<!--    };-->

<!--    const contentMoveTouch = (e: TouchEvent) => {-->
<!--      const changeY = e.changedTouches[0].screenY;-->
<!--      diff.value = start.value - changeY;-->
<!--      if (diff.value <= 0 && contentRef.value.scrollTop === 0 && !props.hideExit) {-->
<!--        frameRef.value.style.height = `${heights.frame.start + diff.value}px`;-->
<!--        contentRef.value.style.height = `${heights.content.start + diff.value}px`;-->
<!--      }-->
<!--    };-->

<!--    const endTouch = () => {-->
<!--      if (heights.frame.default  > frameRef.value.offsetHeight + 50) {-->
<!--        closeSlide();-->
<!--      } else {-->
<!--        contentRef.value.style.touchAction = 'auto'-->
<!--        if (!props.maxHeight) {-->
<!--          frameRef.value.style.height = `fit-content`;-->
<!--          contentRef.value.style.height = `fit-content`;-->
<!--        }-->
<!--      }-->
<!--    };-->

<!--    const clickBack = () => {-->
<!--      if (!props.hideExit) {-->
<!--        closeSlide()-->
<!--      }-->
<!--    }-->


<!--    onUnmounted(() => {-->
<!--      document.body.style.overflow = 'auto'-->
<!--    })-->

<!--    return {-->
<!--      closeSlide,-->
<!--      startTouch,-->
<!--      endTouch,-->
<!--      moveTouch,-->
<!--      contentMoveTouch,-->
<!--      frameRef,-->
<!--      contentRef,-->
<!--      footerRef,-->
<!--      clickBack,-->
<!--    }-->
<!--  }-->
<!--})-->
<!--</script>-->

<!--<style scoped></style>-->
